import React, { FC, useMemo } from "react"
import { IconButton, IconButtonProps, useTheme } from "@mui/material"
import { getIcon } from "utils/icon"
import { SearchIcon } from "components/icons"
import { useAppUI } from "providers/ui"

export const HeaderSearchButton: FC<IconButtonProps> = ({
  size = "large",
  ...props
}) => {
  const theme = useTheme()
  const { openSearch } = useAppUI()
  const styleOverrides =
    theme.components[`AppHeaderSearchButton`]?.styleOverrides || {}
  const { root, icon } = styleOverrides

  const searchIcon = useMemo(
    () => getIcon(theme?.assets?.search, icon) || <SearchIcon />,
    [theme, icon]
  )
  return (
    <IconButton
      edge="start"
      color="inherit"
      aria-label="back"
      sx={root}
      onClick={openSearch}
      {...props}
    >
      {searchIcon}
    </IconButton>
  )
}
